
import React, { useEffect, useState } from "react";

/* =========================================================
   PANEL CARDS
========================================================= */
const getCards = (isStudentLoggedIn, isParentLoggedIn) => [
  // 1. Student
  {
    title: "Student",
    subtitle: "Access student dashboard",
    icon: "🎓",
    url: isStudentLoggedIn ? "/dashboard" : "/student-login",
    buttonText: isStudentLoggedIn ? "Dashboard" : "Login",
    color: "#7c3aed",
    light: "#f5f3ff",
    status: isStudentLoggedIn ? "Logged in" : null,
  },

  // 2. Parent
  {
    title: "Parent",
    subtitle: "Track your child's progress",
    icon: "👨‍👩‍👧",
    url: isParentLoggedIn ? "/Parentdash-board" : "/parent-login",
    buttonText: isParentLoggedIn ? "Dashboard" : "Login",
    color: "#ea580c",
    light: "#fff7ed",
    status: isParentLoggedIn ? "Logged in" : null,
  },

  // 3. Parent Panel
  {
    title: "Teacher",
    subtitle: "Manage classes and students",
    icon: "👨‍🏫",
    url: "https://eduadmin.sindoor7.com/teachern",
    buttonText: "Login",
    color: "#16a34a",
    light: "#f0fdf4",
  },
  // 4. Student Panel
  {
    title: "Student Panel",
    subtitle: "Student panel access",
    icon: "📚",
    url: "https://edustudent.sindoor7.com/",
    buttonText: "Login",
    color: "#db2777",
    light: "#fdf2f8",
  },

  // 5. Teacher



    {
    title: "Parent Panel",
    subtitle: "Parent panel access",
    icon: "📚",
    url: "https://eduparent.sindoor7.com/Login",
    buttonText: "Login",
    color: "#db2777",
    light: "#fdf2f8",
  },

  // 6. School Admin
  {
    title: "School Admin",
    subtitle: "Manage school operations",
    icon: "🏫",
    url: "https://eduadmin.sindoor7.com/school",
    buttonText: "Login",
    color: "#2563eb",
    light: "#eff6ff",
  },
];

/* =========================================================
   COMPONENT
========================================================= */
const EducationDemo = () => {
  const [isStudentLoggedIn, setIsStudentLoggedIn] = useState(
    !!localStorage.getItem("api_token")
  );

  const [isParentLoggedIn, setIsParentLoggedIn] = useState(
    !!localStorage.getItem("api_token_Parent")
  );

  /* =========================================================
     LOGIN TOKEN CHECK
  ========================================================= */
  useEffect(() => {
    const checkLogin = () => {
      // Student token
      setIsStudentLoggedIn(
        !!localStorage.getItem("api_token")
      );

      // Parent token
      setIsParentLoggedIn(
        !!localStorage.getItem("api_token_Parent")
      );
    };

    // Initial check
    checkLogin();

    // Browser/tab focus
    window.addEventListener("focus", checkLogin);

    // Other tab localStorage changes
    window.addEventListener("storage", checkLogin);

    // Student login/logout custom event
    window.addEventListener(
      "studentLoginChanged",
      checkLogin
    );

    // Parent login/logout custom event
    window.addEventListener(
      "parentLoginChanged",
      checkLogin
    );

    return () => {
      window.removeEventListener("focus", checkLogin);
      window.removeEventListener("storage", checkLogin);

      window.removeEventListener(
        "studentLoginChanged",
        checkLogin
      );

      window.removeEventListener(
        "parentLoginChanged",
        checkLogin
      );
    };
  }, []);

  /* =========================================================
     OPEN LOGIN / DASHBOARD
  ========================================================= */
  const openLogin = (url) => {
    // External URL
    if (url.startsWith("http")) {
      window.location.href = url;
      return;
    }

    // Internal React route
    window.location.href = url;
  };

  const cards = getCards(
    isStudentLoggedIn,
    isParentLoggedIn
  );

  return (
    <section className="education-page">
      <div className="education-container">

        {/* HEADER */}
        <header className="education-header">
          <div className="trial-badge">
            <span>✦</span>
            4 Days Free Trial
          </div>

          <h1>Student School Darpan</h1>

          <p>Select your panel to continue</p>
        </header>

        {/* CARDS */}
        <div className="education-grid">
          {cards.map((card) => (
            <article
              key={card.title}
              className="education-card"
              style={{
                "--card-color": card.color,
                "--card-light": card.light,
              }}
            >

              {/* LOGIN STATUS */}
              {card.status && (
                <span className="card-status">
                  <i />
                  {card.status}
                </span>
              )}

              <div className="card-content">

                <div className="card-icon">
                  {card.icon}
                </div>

                <div className="card-info">
                  <h3>{card.title}</h3>
                  <p>{card.subtitle}</p>
                </div>

              </div>

              {/* BUTTON */}
              <button
                type="button"
                className="login-button"
                onClick={() => openLogin(card.url)}
                aria-label={`${card.buttonText} — ${card.title}`}
              >
                <span>{card.buttonText}</span>

                <span className="arrow">
                  →
                </span>
              </button>

            </article>
          ))}
        </div>

        {/* FOOTER */}
        <footer className="education-footer">
          <strong>Student School Darpan</strong>
          <span>•</span>
          <span>4 Days Free Trial</span>
          <span>•</span>
          <span>Secure Panel Access</span>
        </footer>

      </div>

      <style>{`

        /* =====================================================
           EDUCATION DEMO
        ====================================================== */

        .education-page,
        .education-page *,
        .education-page *::before,
        .education-page *::after {
          box-sizing: border-box;
        }

        .education-page {
          width: 100%;
          min-height: 100vh;
          padding: 64px 20px 40px;
          color: #0f172a;

          font-family:
            "Plus Jakarta Sans",
            Inter,
            "Segoe UI",
            Arial,
            sans-serif;

          -webkit-font-smoothing: antialiased;

          background:
            radial-gradient(
              circle at 50% -120px,
              rgba(79, 70, 229, .12),
              transparent 55%
            ),
            linear-gradient(
              180deg,
              #f6f8fd 0%,
              #eef2fb 100%
            );
        }

        .education-page h1,
        .education-page h3,
        .education-page p {
          margin: 0;
        }

        .education-container {
          width: 100%;
          max-width: 1120px;
          margin: 0 auto;
        }

        /* ---------- HEADER ---------- */

        .education-header {
          margin-bottom: 44px;
          text-align: center;
        }

        .trial-badge {
          display: inline-flex;
          align-items: center;
          gap: 8px;

          margin-bottom: 16px;
          padding: 8px 16px;

          font-size: 13px;
          font-weight: 700;

          color: #c2410c;
          background: #fff7ed;

          border: 1px solid #fed7aa;
          border-radius: 999px;
        }

        .education-header h1 {
          font-size: clamp(32px, 5vw, 48px);
          font-weight: 800;
          line-height: 1.12;

          letter-spacing: -1.4px;
          color: #0e1a3a;
        }

        .education-header p {
          margin-top: 10px;

          font-size: 16px;
          font-weight: 500;

          color: #5b6784;
        }

        /* ---------- GRID ---------- */

        .education-grid {
          display: grid;

          grid-template-columns:
            repeat(3, minmax(0, 1fr));

          gap: 22px;
        }

        /* ---------- CARD ---------- */

        .education-card {
          position: relative;

          min-height: 200px;
          padding: 24px;

          display: flex;
          flex-direction: column;
          justify-content: space-between;

          gap: 22px;

          overflow: hidden;

          background: #ffffff;

          border: 1px solid #e0e6f3;
          border-radius: 20px;

          box-shadow:
            0 1px 2px rgba(15, 23, 42, .05),
            0 12px 30px rgba(15, 23, 42, .06);

          transition:
            transform .25s ease,
            box-shadow .25s ease,
            border-color .25s ease;
        }

        .education-card::before {
          content: "";

          position: absolute;

          inset: 0 0 auto 0;

          height: 4px;

          background: var(--card-color);
        }

        .education-card:hover {
          transform: translateY(-5px);

          border-color: var(--card-color);

          box-shadow:
            0 2px 4px rgba(15, 23, 42, .05),
            0 22px 46px rgba(15, 23, 42, .13);
        }

        /* ---------- CARD CONTENT ---------- */

        .card-content {
          display: flex;
          align-items: center;

          gap: 16px;
        }

        .card-icon {
          width: 58px;
          height: 58px;
          min-width: 58px;

          display: flex;
          align-items: center;
          justify-content: center;

          font-size: 27px;

          background: var(--card-light);

          border:
            1px solid
            color-mix(
              in srgb,
              var(--card-color) 18%,
              transparent
            );

          border-radius: 16px;

          transition:
            transform .25s ease;
        }

        .education-card:hover .card-icon {
          transform:
            scale(1.07)
            rotate(-3deg);
        }

        .card-info {
          min-width: 0;
        }

        .card-info h3 {
          font-size: 18px;
          font-weight: 700;

          line-height: 1.3;

          color: #0e1a3a;
        }

        .card-info p {
          margin-top: 4px;

          font-size: 14px;
          font-weight: 500;

          line-height: 1.45;

          color: #5b6784;
        }

        /* ---------- STATUS ---------- */

        .card-status {
          position: absolute;

          top: 16px;
          right: 16px;

          display: inline-flex;
          align-items: center;

          gap: 6px;

          padding: 4px 10px;

          font-size: 12px;
          font-weight: 700;

          color: #15803d;

          background: #f0fdf4;

          border:
            1px solid
            #bbf7d0;

          border-radius: 999px;
        }

        .card-status i {
          width: 7px;
          height: 7px;

          border-radius: 50%;

          background: #22c55e;

          box-shadow:
            0 0 0 3px
            rgba(34, 197, 94, .25);
        }

        /* ---------- BUTTON ---------- */

        .login-button {
          width: 100%;
          height: 46px;

          display: flex;
          align-items: center;
          justify-content: center;

          gap: 10px;

          font-family: inherit;

          font-size: 15px;
          font-weight: 700;

          color: #ffffff;

          cursor: pointer;

          background: var(--card-color);

          border: 0;
          border-radius: 12px;

          box-shadow:
            0 8px 18px
            color-mix(
              in srgb,
              var(--card-color) 32%,
              transparent
            );

          transition:
            transform .2s ease,
            filter .2s ease,
            box-shadow .2s ease;
        }

        .login-button:hover {
          filter: brightness(.93);

          transform:
            translateY(-2px);

          box-shadow:
            0 12px 24px
            color-mix(
              in srgb,
              var(--card-color) 42%,
              transparent
            );
        }

        .login-button:active {
          transform: scale(.98);
        }

        .login-button:focus-visible {
          outline: 3px solid #f4a300;
          outline-offset: 3px;
        }

        .arrow {
          font-size: 17px;
          line-height: 1;

          transition:
            transform .2s ease;
        }

        .login-button:hover .arrow {
          transform:
            translateX(5px);
        }

        /* ---------- FOOTER ---------- */

        .education-footer {
          margin-top: 36px;

          display: flex;
          flex-wrap: wrap;

          align-items: center;
          justify-content: center;

          gap: 8px;

          font-size: 13px;
          font-weight: 500;

          color: #7a86a1;
        }

        .education-footer strong {
          font-weight: 700;
          color: #4b5878;
        }

        /* ---------- RESPONSIVE ---------- */

        @media (max-width: 900px) {
          .education-grid {
            grid-template-columns:
              repeat(2, minmax(0, 1fr));
          }
        }

        @media (max-width: 600px) {
          .education-page {
            margin-top: 50px;
            padding: 36px 14px 28px;
          }

          .education-header {
            margin-bottom: 30px;
          }

          .education-header h1 {
            font-size: 30px;
            letter-spacing: -1px;
          }

          .education-header p {
            font-size: 15px;
          }

          .education-grid {
            grid-template-columns: 1fr;
            gap: 16px;
          }

          .education-card {
            min-height: 0;
            padding: 20px;
          }
        }

        @media (prefers-reduced-motion: reduce) {
          .education-page *,
          .education-page *::before,
          .education-page *::after {
            transition-duration: .01ms !important;
          }
        }

      `}</style>
    </section>
  );
};

export default EducationDemo;
